/**
 * Internacionalización de barra de digitalización
 */
const drawLocal = {
  draw: {
    toolbar: {
      actions: {
        title: 'Cancelar la digitalización',
        text: 'Cancelar'
      },
      finish: {
        title: 'Finalizar la digitalización',
        text: 'Finalizar'
      },
      undo: {
        title: 'Elimina el último punto digitalizado.',
        text: 'Eliminar último punto.'
      },
      buttons: {
        polygon: 'Dibujar un poligono',
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: 'Click and drag to draw circle.'
        },
        radius: 'Radius'
      },
      circlemarker: {
        tooltip: {
          start: 'Click map to place circle marker.'
        }
      },
      marker: {
        tooltip: {
          start: 'Click map to place marker.'
        }
      },
      polygon: {
        tooltip: {
          start: 'Clic para empezar a digitalizar la figura',
          cont: 'Clic para continuar digitalizando la figura.',
          end: 'Clic en el primer punto para finalizar la figura'
        }
      },
      polyline: {
        error: '<strong>Error:</strong> shape edges cannot cross!',
        tooltip: {
          start: 'Click to start drawing line.',
          cont: 'Click to continue drawing line.',
          end: 'Click last point to finish line.'
        }
      },
      rectangle: {
        tooltip: {
          start: 'Click and drag to draw rectangle.'
        }
      },
      simpleshape: {
        tooltip: {
          end: 'Release mouse to finish drawing.'
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: 'Guardar Cambios',
          text: 'Guardar'
        },
        cancel: {
          title: 'Cancelar edición, descarta los cambios realizados.',
          text: 'Cancelar'
        },
        clearAll: {
          title: 'Elimina todos los elementos',
          text: 'Eliminar Todo'
        }
      },
      buttons: {
        edit: 'Editar elementos',
        editDisabled: 'No hay elementos para editar',
        remove: 'Borrar elementos',
        removeDisabled: 'No hay elementos para borrar'
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: 'Arrastre los puntos para editar los elementos.',
          subtext: 'Clic en cancelar para deshacer cambios.'
        }
      },
      remove: {
        tooltip: {
          text: 'Haga clic en un elemento para eliminarlo'
        }
      }
    }
  }
};

export default drawLocal;

